import { DomSanitizer } from '@angular/platform-browser';
import { IdNameApiModel } from '@app/api/api-models/IdNameApiModel';
import { ProgramExitTypeSelectorApiModel } from '@app/api/api-models';
import { ActivityTypeListApiModel } from '@app/api/api-models';
import { AssignmentSkillSelectorApiModel } from '@app/api/api-models/pending-tasks';
import { AssignmentPerformanceCategorySelectorApiModel } from '@app/api/api-models/pending-tasks';
import { PhaseSelectorApiModel } from './PhaseSelectorApiModel';
import { AssignmentCallTypeSelectorApiModel } from '@app/api/api-models/pending-tasks/AssignmentCallTypeSelectorApiModel';

export class FormInstanceSelectorsApiModel {
  public ProgramExitTypes = new Array<ProgramExitTypeSelectorApiModel>();
  public Phases = new Array<PhaseSelectorApiModel>();
  public Skills = new Array<AssignmentSkillSelectorApiModel>();
  public SkillHeadings = new Array<IdNameApiModel>();
  public PerformanceCategories = new Array<AssignmentPerformanceCategorySelectorApiModel>();
  public PerformanceCategoryHeadings = new Array<IdNameApiModel>();
  public CallTypes = new Array<AssignmentCallTypeSelectorApiModel>();
  public CallTypeHeadings = new Array<IdNameApiModel>();
  public Locations = new Array<IdNameApiModel>();
  public Shifts = new Array<IdNameApiModel>();
  public ActivityTypes = new Array<ActivityTypeListApiModel>();

  public deserialize(data: Object, domSanitizer: DomSanitizer): FormInstanceSelectorsApiModel {
    Object.assign(this, data);

    this.ActivityTypes = this.ActivityTypes.map((x) => new ActivityTypeListApiModel().deserialize(x));
    this.ProgramExitTypes = this.ProgramExitTypes.map((x) =>
      new ProgramExitTypeSelectorApiModel().deserialize(x, domSanitizer)
    );

    return this;
  }
}
